export default "__VITE_ASSET__CB4COTL0__"